import * as models from "./Models";
import { init } from "@rematch/core";

const store = init({ models });
export default store;
